module.exports = __webpack_public_path__ + "img/varoszoba_enterior_2.073951a3.jpg";